<template>
  <div class="smart">
    <!-- banner部分 -->
    <div class="smart-banner clearfix">
      <div>
        <h2>智慧校园</h2>
        <h3>智能录播系统</h3>
      </div>
    </div>
    <!-- 方案概述 -->
    <div class="container clearfix">
      <div class="smart-title">方案概述</div>
      <div class="smart-overview mb100">
        <!-- <div class="fl">
          <img src="../../../assets/img/smart/lubo_summary_Image.png" alt="" />
        </div> -->
        <div>
          <h2>智能录播系统</h2>
          <p>
            录播系统整体解决方案以卓越的音视频质量，自动跟踪和协作技 术，强大完善的通讯功能、稳定的系统性能提供给用户一个全方 位、多层次、高效率的数字化实景多媒体教学平台。平台具有高 清的视频，真实的课堂效果，实时交互性强等显著特点，非常适 用于跨班级、跨学校之间的多媒体互动教学的场景下使用，是一 套集教学、学习、管理、存储、工享为一体的高效应用解决方案；集
            校级资源管理、直播、点播功能于一体，操作简单，直观，便于常态化教学。
          </p>
        </div>
      </div>
    </div>
    <!-- 方案架构 -->
    <div class="container clearfix">
      <div class="smart-title">方案架构</div>
      <div class="smart-schema mb100">
        <img src="../../../assets/img/smart/znlb_framework_Image .png" alt="" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'SswisdomRecordbroad',
};
</script>
<style scoped>
.smart-banner {
  width: 100%;
  height: 594px;
  background: #000;
}
.smart-banner div {
  overflow: hidden;
  width: 100%;
  height: 100%;
  background: url(../../../assets/img/smart/background_Image.png) no-repeat 0 0;
  background-size: cover;
}
.smart-banner h2 {
  margin-top: 182px;
  text-align: center;
  font-size: 100px;
  font-weight: bold;
  color: #fff;
}
.smart-banner h3 {
  text-align: center;
  font-size: 30px;
  font-weight: 400;
  color: #fff;
}
.smart-title {
  width: 100%;
  margin-top: 100px;
  margin-bottom: 100px;
  text-align: center;
  font-size: 60px;
  font-weight: bold;
  color: #000;
}
/* .smart-overview {
  width: 100%;
  height: 334px;
}
.smart-overview .fl {
  width: 370px;
  height: 100%;
}
.smart-overview .fl img {
  width: 100%;
  height: 100%;
}
.smart-overview .fr {
  margin-left: 50px;
  width: 777px;
  padding: 51px 0;
}
.smart-overview .fr p {
  font-size: 18px;
  font-weight: 400;
  color: #666;
  text-indent: 2em;
  line-height: 1.8;
}
.smart-overview .fr h2 {
  margin-bottom: 45px;
  font-size: 24px;
  font-weight: bold;
  color: #000;
} */
.smart-overview {
  width: 100%;
  height: 334px;
}
.smart-overview p {
  font-size: 18px;
  font-weight: 400;
  color: #666;
  text-indent: 2em;
  line-height: 1.8;
}
.smart-overview h2 {
  text-align: center;
  margin-bottom: 45px;
  font-size: 24px;
  font-weight: bold;
  color: #000;
}
</style>
